import { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
//primereact
import { confirmDialog } from "primereact/confirmdialog";
//services
import { getIndex } from "../../../../../../services/GlobalRoles/getIndex";
import { getParcel } from "../../../../../../services/Parcel/getParcel";
import { linkParcel } from "../../../../../../services/Parcel/linkParcel";
import { updateParcels } from "../../../../../../services/Parcel/updateParcel";
import { generateShipping } from "../../../../../../services/Parcel/generateShipping";
import { anticipateReversal } from "../../../../../../services/Parcel/anticipateReversal";
import { getParcelDescription } from "../../../../../../services/GlobalRoles/getParcelDescription";
import { useAppContext } from "../../../../../../context/AppContext";

const ParcelContext = createContext();

export function ParcelProvider({ children }) {
  let location = useLocation();


  const { permissions } = useAppContext();

  const idSale = location.state && location.state.id ? location.state.id : null;
  const enterpriseId =
    location.state && location.state.enterpriseId
      ? location.state.enterpriseId
      : null;
  const nameCli =
    location.state && location.state.name_cli ? location.state.name_cli : null;

  const typeSale =
    location.state && location.state.type_sale ? location.state.type_sale : null;

  const nameBlock =
    location.state && location.state.block ? location.state.block : null;
  const nameLand =
    location.state && location.state.land ? location.state.land : null;

  // states
  const [itemsSelected, setItemsSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false); //Adicionar um estado para selecionar todas as parcelas
  //VARIÁVEIS

  const [isModalVisible, setIsModalVisible] = useState(false); // Adicione um estado para controlar a visibilidade do modal

  const [isModalVisibleUpdateDueDate, setIsModalVisibleUpdateDueDate] =
    useState(false); // Modal de Alterar Datas de Vencimento
  const [isModalVisibleAlterDesc, setIsModalVisibleAlterDesc] = useState(false); // Modal de Alterar Instruções do Boleto
  const [isModalVisibleAddParcel, setIsModalVisibleAddParcel] = useState(false); // Modal de Adicionar Parcelas
  const [
    isModalVisibleUpdateInstallments,
    setIsModalVisibleUpdateInstallments,
  ] = useState(false); // Modal para Atualizar Parcela
  const [
    isModalVisibleAnticipateRegressive,
    setIsModalVisibleAnticipateRegressive,
  ] = useState(false); // Modal de Antecipar Parcelas Regressivamente
  const [
    isModalVisibleAnticipateSelected,
    setIsModalVisibleAnticipateSelected,
  ] = useState(false); // Modal de Antecipar Parcelas Selecionadas
  const [isModalVisibleRenegotiate, setIsModalVisibleRenegotiate] =
    useState(false); // Modal de Renegociação
  const [isModalVisibleReverse, setIsModalVisibleReverse] = useState(false); // Modal para Voltar Parcelas Estornadas
  const [isModalVisibleReverseShipping, setIsModalVisibleReverseShipping] = useState(false); // Modal para Voltar Parcelas Estornadas
  const [isModalVisibleReadjust, setIsModalVisibleReadjust] = useState(false); // Modal para Reajustar Parcelas
  const [isModalVisibleCalculate, setIsModalVisibleCalculate] = useState(false); // Estado para Controlar botão de Confirmar dentro das modals
  const [isVisibleButtons, setIsVisibleButtons] = useState(true); // Estado para controlar botões para impressão do boleto

  const [selectedValue, setSelectedValue] = useState([]);
  const [loadingUpdate, setLoadingUpdate] = useState(null);
  const [selectedOptionStatus, setSelectedOptionStatus] = useState(null);
  // Definir um estado para controlar a exibição dos checkboxes
  const [showCheckboxes, setShowCheckboxes] = useState(true);

  const handleConfirmButtonClickLink = (status) => {
    const selectedParcelIds = itemsSelected.map(
      (selectedParcel) => selectedParcel.id
    );
    acceptAlter(status, [], selectedParcelIds);
  };
  const handleOptionSelect = (newOption) => {
    setSelectedOptionStatus(newOption);
    let confirmationMessage;

    switch (newOption) {
      case "change_due_date":
        if (itemsSelected.length > 0) {
          setIsModalVisibleUpdateDueDate(!isModalVisibleUpdateDueDate);
        } else {
          toast.warning("Selecione ao menos uma parcela.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }
        break;

      case "alter_desc":
        if (itemsSelected.length > 0) {
          setIsModalVisibleAlterDesc(!isModalVisibleAlterDesc);
        } else {
          toast.warning("Selecione ao menos uma parcela.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }
        break;

      case "update_installment":

        if ((
          objExpired.length > 0 &&
          objExpired.length === itemsSelected.length
        )
          && (objCode.length <= 0
            && objExpired.length === itemsSelected.length)
        ) {
          setIsModalVisibleUpdateInstallments(
            !isModalVisibleUpdateInstallments
          );
        } else {
          toast.warning("Selecione apenas parcelas vencidas!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }
        break;

      case "create_parcel":
        setIsModalVisibleAddParcel(!isModalVisibleAddParcel);
        break;

      case "anticipate_regressive":
        setIsModalVisibleAnticipateRegressive(
          !isModalVisibleAnticipateRegressive
        );
        break;

      case "anticipate_selected":
        // console.log(objExpired);
        if ((objExpired.length === 0 && itemsSelected.length > 0) &&
          (objCode.length <= 0)
        ) {
          setIsModalVisibleAnticipateSelected(
            !isModalVisibleAnticipateSelected
          );
        } else {
          toast.warning("Seleciona apenas parcelas não vinculadas, ou à vencer.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }

        break;

      case "renegotiate":
        if (itemsSelected.length > 0) {
          setIsModalVisibleRenegotiate(!isModalVisibleRenegotiate);
          setIsModalVisibleCalculate(true);
        } else {
          toast.warning("Selecione ao menos uma parcela.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }

        break;

      case "readjust_installments":
        if (objExpired.length === 0 && itemsSelected.length > 0) {
          setIsModalVisibleReadjust(!isModalVisibleReadjust);
        } else {
          toast.warning("Selecione apenas parcelas à vencer.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }

        break;
      case "reverse_installments":
        setIsModalVisibleReverse(!isModalVisibleReverse);
        break;

      case "link":
        if (itemsSelected.length > 1) {
          confirmationMessage = "Deseja fazer o vinculo?";
        } else {
          toast.warning("Selecione ao menos duas parcela.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }

        break;
      case "shipping":
        if (itemsSelected.length > 0 && objExpiredWithBilletCheck.length == 0) {
          confirmationMessage = "Deseja gerar a remessa?";
        } else if (objExpiredWithBilletCheck.length > 0) {
          toast.warning("Selecione apenas parcelas à vencer.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
          break;
        } else {
          toast.warning("Selecione ao menos uma parcela.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
          break;
        }

        break;
      case "reverse_shipping":
        setIsModalVisibleReverseShipping(!isModalVisibleReverseShipping);
        break;
      case "remove_anticipate":
        if (itemsSelected.length > 0) {
          confirmationMessage = "Deseja fazer o estorno da Antecipação?";
        } else {
          toast.warning("Selecione ao menos uma parcela.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }

        break;

      case "remove_link":
        if (itemsSelected.length > 0) {
          confirmationMessage = "Deseja desfazer o vinculo?";
        } else {
          toast.warning("Selecione ao menos uma parcela.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }
        break;

      default:
        break;
    }

    if (confirmationMessage) {
      confirmDialog({
        message: confirmationMessage,
        header: "Confirmação",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: function (event) {
          handleConfirmButtonClickLink(newOption);
        },
        onHide: function () {
          setSelectedOptionStatus(null); // Limpar o estado após fechar o diálogo
        },
      });
    }
  };

  //ENVIAR REQUISIÇÃO
  const acceptAlter = async (action, value, idsParcels) => {
    setIsModalVisibleAlterDesc(false);
    setIsModalVisible(false);
    setIsModalVisibleAddParcel(false);

    let obj = {
      action: action,
      sale_id: idSale,
      installments: {},
      installments_id: {},
    };

    let notificationMessage;
    let toastFunction;

    switch (action) {
      case "change_due_date":
        obj.date = value.due_date;
        idsParcels.forEach((id, index) => {
          obj.installments[index] = {
            id: id,
          };
        });
        notificationMessage = "Alteração de data realizada com sucesso!";
        toastFunction = updateParcels;
        break;

      case "link":
      case "remove_link":
        idsParcels.forEach((id, index) => {
          obj.installments[index] = {
            id: id,
          };
        });

        notificationMessage =
          action === "link"
            ? "Parcelas vinculadas com sucesso!"
            : "Parcelas desvinculadas com sucesso!";
        toastFunction = linkParcel;
        break;

      case "shipping":
        const arrByID = idsParcels?.map((id, row) => {
          return id; // return just id
        });
        obj.installments_id = arrByID;
        obj.enterprise_id = enterpriseId;

        notificationMessage = "Parcelas enviadas para a fila de remessa!";
        toastFunction = generateShipping;
        break;

      case "remove_anticipate":
        idsParcels.forEach((id, index) => {
          obj.installments_id[index] = {
            id,
          };
        });

        notificationMessage = "Antecipação Desfeita!";
        toastFunction = anticipateReversal;
        break;

      default:
        break;
    }

    const notification = toast.loading(
      "Por favor aguarde, a ação está sendo realizada..."
    );
    try {
      setLoadingUpdate(true);

      // Mostra o toast de loading enquanto a ação está sendo processada


      // Executa a função correspondente
      const response = await toastFunction(obj);

      await refetch(); // Aguarda o refetch terminar

      if (response.success) {
        // Atualiza o toast para sucesso
        toast.update(notification, {
          render: notificationMessage,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      } else {
        // Atualiza o toast para erro com a mensagem específica
        const errorMessage =
          response.error && response.error
            ? response.error
            : "Não foi possível fazer a ação.";

        toast.update(notification, {
          render: errorMessage,
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      }
    } catch (error) {
      console.log(error)
      // Caso um erro seja capturado, mostra o toast de erro
      const errorMessage =
        error.message || "Ocorreu um erro inesperado.";

      toast.update(notification, {
        render: errorMessage,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });

      await refetch(); // Refaz o refetch mesmo em caso de erro
    } finally {
      setLoadingUpdate(false);
      setItemsSelected([]);
      // setSelectedValue(null); // Se precisar resetar valores
    }
  };



  //MODAL DE CONFIRMAÇÃO DE ALTERAÇÕES DAS PARCELAS
  const confirm = (selectedOptionStatus, selectedValue) => {
    let questionMessage;
    const selectedParcelIds = itemsSelected.map(
      (selectedParcel) => selectedParcel.id
    );

    questionMessage =
      selectedOptionStatus === "create_parcel"
        ? "Deseja adicionar as Parcelas?"
        : "Deseja fazer a alteração?";
    confirmDialog({
      message: questionMessage,
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: function (event) {
        acceptAlter(selectedOptionStatus, selectedValue, selectedParcelIds);
      },
    });
  };

  const handleConfirmButtonClick = () => {
    confirm(selectedOptionStatus, selectedValue);
  };
  // Função para alternar o modo de exibição dos checkboxes
  const toggleCheckboxes = () => {

    setIsVisibleButtons(!isVisibleButtons);
    setShowCheckboxes(!showCheckboxes);
    setSelectAll(false);
    setItemsSelected([]);
  };

  //USE QUERY PARA LISTAR / ATUALIZAR LISTA DE PARCELAS
  const {
    data: parcels,
    refetch,
    isLoading: isLoadingParcel,
  } = useQuery({
    queryKey: [`parcels${idSale}`],
    queryFn: () => getParcel(idSale),
    enabled: !!permissions?.includes("36")
  });

  // Busca Indices de Reajustes
  const {
    data: index,
    refetch: refreshIndex,
    isLoading: isLoadingIndex,
  } = useQuery({
    queryKey: [`index`],
    queryFn: () => getIndex(),
    enabled: !!permissions?.includes("149")
  });
  let transformedObj = [];
  if (!isLoadingIndex && index) {
    transformedObj = index.flatMap((item) =>
      item.config_index.map((config) => ({
        label: `${item.name} - ${config.name} / Índice: ${config.index} Juros: ${config.fee}`,
        value: config.id,
        index_value: config.index, // Adiciona o valor de config.index
        fee: config.fee, // Adiciona o valor de config.fee
      }))
    );
  }
  //Buscar descrição de Parcelas
  const { data: parcelsDescription } = useQuery({
    queryKey: ["parcelDescription"],
    queryFn: () => getParcelDescription(),
    enabled: !!permissions?.includes("140")
  });

  // Verificar Antecipação com a Data Atual
  const dataAtual = new Date();
  dataAtual.setHours(0, 0, 0, 0);
  const objExpired = itemsSelected.filter((objeto) => {
    const dueDate = new Date(objeto.due_date);
    dueDate.setDate(dueDate.getDate() + 1);
    dueDate.setHours(0, 0, 0, 0);
    return dueDate < dataAtual;
  });

  const objExpiredWithBilletCheck = itemsSelected.filter((objeto) => {
    const dateToCheck = objeto.date_billet && objeto.date_billet !== ""
      ? new Date(objeto.date_billet)
      : new Date(objeto.due_date);

    dateToCheck.setDate(dateToCheck.getDate() + 1); // Ajuste para a data de vencimento
    dateToCheck.setHours(0, 0, 0, 0); // Remove a hora da data de verificação

    return dateToCheck < dataAtual;
  });


  const objCode = itemsSelected.filter((objeto) => {
    return objeto.cod_link > 0;
  });

  return (
    <ParcelContext.Provider
      value={{
        location,
        parcels,
        idSale,
        enterpriseId,
        nameCli,
        nameBlock,
        nameLand,
        typeSale,
        parcelsDescription,
        refreshIndex,
        dataAtual,
        objExpired,
        objCode,
        transformedObj,
        toggleCheckboxes,
        handleConfirmButtonClick,
        acceptAlter,
        confirm,
        handleConfirmButtonClickLink,
        isModalVisibleUpdateDueDate,
        itemsSelected,
        setItemsSelected,
        selectAll,
        setSelectAll,
        setIsModalVisibleUpdateDueDate,
        isModalVisible,
        setIsModalVisible,
        isModalVisibleAlterDesc,
        setIsModalVisibleAlterDesc,
        isModalVisibleAddParcel,
        setIsModalVisibleAddParcel,
        isModalVisibleUpdateInstallments,
        setIsModalVisibleUpdateInstallments,
        isModalVisibleAnticipateRegressive,
        setIsModalVisibleAnticipateRegressive,
        isModalVisibleAnticipateSelected,
        setIsModalVisibleAnticipateSelected,
        isModalVisibleRenegotiate,
        setIsModalVisibleRenegotiate,
        isModalVisibleReadjust,
        setIsModalVisibleReadjust,
        setIsModalVisibleReverse,
        isModalVisibleReverse,
        setIsModalVisibleReverseShipping,
        isModalVisibleReverseShipping,
        isModalVisibleCalculate,
        setIsModalVisibleCalculate,
        isVisibleButtons,
        setIsVisibleButtons,
        selectedValue,
        setSelectedValue,
        loadingUpdate,
        setLoadingUpdate,
        selectedOptionStatus,
        setSelectedOptionStatus,
        showCheckboxes,
        setShowCheckboxes,
        refetch,
        isLoadingParcel,
        handleOptionSelect,
        permissions
      }}
    >
      {children}
    </ParcelContext.Provider>
  );
}

export function useParcelContext() {
  return useContext(ParcelContext);
}
